import classNames from 'classnames';
import React, { JSX, ReactNode } from 'react';

interface Props {
  asRow?: boolean;
  className?: string;
  children: ReactNode;
}

export default function FormField({ children, className, asRow }: Props): JSX.Element {
  return (
    <div
      className={classNames('flex mt-4', className, {
        'flex-col': !asRow,
      })}
    >
      {children}
    </div>
  );
}
